import { NavLink } from "react-router-dom";

export default function ProfileHeader() {
  return (
    <div className="profile-tabs-shell">
      <div className="profile-tabs">
        <NavLink
          to="/profile"
          className={({ isActive }) =>
            `profile-tab ${isActive ? "is-active" : ""}`
          }
        >
          My Profile
        </NavLink>
        <NavLink
          to="/account-settings"
          className={({ isActive }) =>
            `profile-tab ${isActive ? "is-active" : ""}`
          }
        >
          Account Settings
        </NavLink>
      </div>
    </div>
  );
}
